import { CollectionYardVisitEvent } from "../../../types/collectionYards";
import { useTranslation } from "react-i18next";
import { BoxWithDividerLines } from "../../BoxWithDividerLines";
import { CollectionYardVisitEventItem } from "../CollectionYardVisitEventItem/CollectionYardVisitEventItem";

type CollectionYardVisitEventsProps = {
  events: CollectionYardVisitEvent[];
};

export const CollectionYardVisitEvents: React.FC<CollectionYardVisitEventsProps> = ({ events }) => {
  const { t } = useTranslation();

  const collectionBoxItems = events.map(event => ({
    id: event.eventId,
    element: <CollectionYardVisitEventItem event={event} />,
  }));

  if (events.length === 0) {
    return <div>{t("noData")}</div>;
  }

  return <BoxWithDividerLines style={{ padding: "0.55rem" }} items={collectionBoxItems} />;
};
